"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ListItem = require("../../components/ListItem/ListItem.styles");
var _listResetMixin = require("../listResetMixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  if (appearance === 'none') {
    return '';
  }
  return (0, _styledToken.default)({
    borderColor: 'List.borderColor',
    borderWidth: 'List.borderWidth',
    paddingLeft: 'List.paddingLeft',
    itemPaddingTop: 'List.Item.paddingTop',
    itemPaddingRight: 'List.Item.horizontalTable.paddingRight',
    itemPaddingBottom: 'List.Item.paddingBottom',
    itemPaddingLeft: 'List.Item.horizontalTable.paddingLeft'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      paddingLeft = _ref.paddingLeft,
      itemPaddingTop = _ref.itemPaddingTop,
      itemPaddingRight = _ref.itemPaddingRight,
      _ref$itemPaddingBotto = _ref.itemPaddingBottom,
      itemPaddingBottom = _ref$itemPaddingBotto === void 0 ? 0 : _ref$itemPaddingBotto,
      itemPaddingLeft = _ref.itemPaddingLeft;
    if (appearance === 'horizontalTable') {
      return (0, _styledComponents.css)(["", "{padding-left:", ";padding-right:", ";&:not(:last-child){border-bottom:", "px solid ", ";}}"], _ListItem.StyledListItem, itemPaddingLeft ? itemPaddingLeft + "px" : (0, _spaceMixin.spaceMixin)('sm'), itemPaddingRight ? itemPaddingRight + "px" : (0, _spaceMixin.spaceMixin)('sm'), borderWidth, borderColor);
    }
    var styles = [(0, _styledComponents.css)(["padding-left:", ";", " ", "{&:first-child{padding-top:", "px;}&:last-child{padding-bottom:", ";}}"], paddingLeft ? paddingLeft + "px" : (0, _spaceMixin.spaceMixin)('lg'), _ListItem.StyledListItem, _ListItem.StyledListItem, (0, _spaceMixin.spaceMixin)(itemPaddingTop, function (space) {
      return space.value * 2;
    }), itemPaddingBottom)];
    if (appearance === 'bullet') {
      styles.push((0, _styledComponents.css)(["", "{list-style-type:disc;}"], _ListItem.StyledListItem));
    }
    if (appearance === 'number') {
      styles.push((0, _styledComponents.css)(["", "{list-style-type:decimal;}"], _ListItem.StyledListItem));
    }
    return styles;
  })(props);
};

/** @class ListMixin */
/** @method */
var ListMixin = function ListMixin(props) {
  return (0, _styledToken.default)('List.fontType', function (fontType) {
    return [(0, _listResetMixin.listResetMixin)(props), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), appearanceCSS(props), (0, _spacingMixin.spacingMixin)(props)];
  })(props);
};
exports.ListMixin = ListMixin;